import React from "react";

import { CustomButton } from "../custom-button";

import css from "./custom-toolbar.module.css";

const CustomToolbar = ({
  title,
  btnTitle,
  onClick,
  toolbarBtnVisible
}) => {
  return (
    <div className={css.toolbar}>
      <h1>{title}</h1>

      {toolbarBtnVisible &&
        <CustomButton
        label={btnTitle}
        color="secondary"
        onClick={onClick}
      />
      
      }
    
    </div>
  );
}

export default CustomToolbar;
